import React, { FC, useRef, useState } from "react";
import classNames from "classnames";
import Slick from "react-slick";
import { VideoCard, VideoCardProps } from "./components/video-card/VideoCard";
import { Slider } from "./components/slider/Slider";

export interface VideoCardsProps {
  items: Pick<VideoCardProps, "title" | "excerpt" | "youtubeId">[];
}

export const VideoCards: FC<VideoCardsProps> = ({ items }) => {
  const slider = useRef<Slick>();
  const [playing, setPlaying] = useState<number>();

  const handleOnPlay = (index: number) => () => {
    setPlaying(index);
    if (slider?.current) {
      slider?.current?.slickPause();
    }
  };

  const handleOnStop = () => () => {
    setPlaying(undefined);
    if (slider?.current) {
      slider?.current?.slickPlay();
    }
  };

  return (
    <Slider
      innerRef={slider}
      className={classNames(
        "[&div>div>div:not(:last-child)]:border-r [&div>div>div:not(:last-child)]:border-[#292929]",
      )}
      options={{
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 4000,
        centerMode: false,
        variableWidth: true,
        infinite: false,
        pauseOnHover: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              autoplay: true,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      }}
    >
      {items.map((p, i) => (
        <div
          key={p.title + i}
          className={classNames(
            "max-w-[546px] min-w-full p-0 [&:not(:last-child)]:mb-20",
            "[&:not(:last-child)]:md:mb-0",
          )}
        >
          <VideoCard
            {...p}
            onPlay={handleOnPlay(i)}
            onStop={handleOnStop}
            isPlaying={playing === i}
          />
        </div>
      ))}
    </Slider>
  );
};
